/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Search_Created_FromInputs */



/**
* | output |
* | --- |
* | "Created from" |
*
* @param {Explorer_Search_Created_FromInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_search_created_from = /** @type {((inputs?: Explorer_Search_Created_FromInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Search_Created_FromInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Created from")
	if (locale === "de") return /** @type {LocalizedString} */ ("Created from")
	if (locale === "it") return /** @type {LocalizedString} */ ("Created from")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Created from")
	if (locale === "es") return /** @type {LocalizedString} */ ("Created from")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Created from")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Created from")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Created from")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Created from")
	return /** @type {LocalizedString} */ ("Created from")
});